import '../estilos/partials.css';
import {useLocation,  useParams, useNavigate, Link} from 'react-router-dom';
import React, {useState, useEffect} from "react";
import axios from "axios";
import ContenedorFiltrosGlobal from '../paginas/webGlobal/contenedorFiltrosGlobal.jsx';


function HeaderGlobal(){

  const navigate    = useNavigate();

  const [usuario, setUsuario]   = useState(null);
  const [cargando, setCargando] = useState(true);
  // contenedor filtro: 
  const [filtrosVisibles, setFiltrosVisibles] = useState(false);



  useEffect(() => {
    const verifToken  = axios.get("/verificar-token", {  withCredentials: true  });

    Promise.all([verifToken])
    .then(([resVerif]) => {
      //console.log("resverif: ", resVerif);
      if (resVerif.status === 200) {  setUsuario(resVerif.data.usuario); }
    })
    .catch((err) => {  console.error("Error al inicializar:", err); })
    .finally(() => { setCargando(false); });

        





    const header = document.querySelector('.sticky-header');
    const modal = document.getElementById('modalBusqueda');

    // Al abrir el modal, desactivar el 'position: sticky'
    const onModalOpen = () => { header.style.position = 'static'; };
    // Al cerrar el modal, restaurar el 'position: sticky'
    const onModalClose = () => { header.style.position = 'sticky';  };
    // Agregar los event listeners para el modal de Bootstrap
    modal.addEventListener('show.bs.modal', onModalOpen);
    modal.addEventListener('hide.bs.modal', onModalClose);

    const offcanvasElement = document.getElementById('offcanvasMenu');
    const offcanvasBody = offcanvasElement.querySelector('.offcanvas-body ul');

    // Evento de Bootstrap para cuando el menú se abre
    offcanvasElement.addEventListener('show.bs.offcanvas', () => {
      offcanvasBody.style.opacity = 1;
      offcanvasBody.style.visibility = 'visible';
    });

    // Evento para cuando el menú se cierra
    offcanvasElement.addEventListener('hide.bs.offcanvas', () => {
      offcanvasBody.style.opacity = 0;
      offcanvasBody.style.visibility = 'hidden';
    });
    return ()=> {
        localStorage.setItem("paginaActual",1);
        modal.removeEventListener('show.bs.modal', onModalOpen);
        modal.removeEventListener('hide.bs.modal', onModalClose);
        
    }
  }, []);

  

  async function iniciarsesion(){
  
      var urlAver = "/iniciar-sesion";
      navigate(urlAver);
      window.location.reload();
  }
  async function registrar(){
  
      var urlAver = "/registrar";
      navigate(urlAver);
      window.location.reload();
  }
  
  async function ejectuarBusqueda(datos){
    let tipoDeBusqueda   = datos.tipo;      // búsqueda o filtro
    let busquedaForm = datos.busqueda       // Lo que el usuario escribe en el input
    .toLowerCase()                          // Convertir a minúsculas
    .trim()                                 // Eliminar espacios al inicio y al final
    .replace(/\s+/g, '-');                  // Reemplazar espacios intermedios por guiones
    let cualFiltroForm   = datos.cualFiltro;      // cual filtor selecciona el usuario
    let contenidoFiltroF = datos.contenidoFiltro; // contenido del filtro seleccionado
    
    // pagina: paginaActual, tipoBusqueda: tipoBusquedaNuevo, cualFiltro: cualFiltroNuevo, contenido: contenidoNuevo
    if(tipoDeBusqueda==="busqueda"){
      // actualizar variables de localstorge
      localStorage.setItem("tipoBusquedaNuevo", tipoDeBusqueda); // busquieda 
      localStorage.setItem("contenidoNuevo", busquedaForm); // lo que el usuario escribe 

      let urlAver = "/videos";
      navigate(urlAver);
      window.location.reload();
    }
    else if(tipoDeBusqueda==="filtro"){
      //actualizar variables de localstorage
      localStorage.setItem("tipoBusquedaNuevo",tipoDeBusqueda); // actualizamos a filtro
      localStorage.setItem("contenidoNuevo", contenidoFiltroF); // actualizamos el contenido 
      localStorage.setItem("cualFiltroNuevo", cualFiltroForm);

      let urlAver = "/videos";
      navigate(urlAver);
      window.location.reload();
    }
  }

  function cerrarSesion(event) {
    // evita el parpadeo predefinido
    event.preventDefault();
    setCargando(true);

    localStorage.clear(); // Limpiamos el almacenamiento local.
    axios.post("/logout")
    .then(function(response) {
      setCargando(false);
      console.log(response);
      navigate("/"); // Redirige a la página principal
      window.location.reload(); // Recarga la página para asegurarse de que todo se restablece.
    })
    .catch(function(error) {
      console.error("Error al cerrar sesión:", error);
    });
  }
  

  const toggleFiltros = () => { setFiltrosVisibles(!filtrosVisibles);   };
   
  //console.log("usuario desde headerglobal: ", usuario);
  

  return(
  <div className='sticky-header'>
    <header className="navbar navbar-expand-sm navbar-dark py-3 px-5 container " aria-label="Third navbar example">
      <div className="container-fluid d-flex flex-wrap justify-content-center">
      {/* Contenedor para imagen, filtro y menú en pantallas pequeñas */}
      <ul className="barra mb-4 d-flex align-items-center mx-2 w-100 justify-content-between d-lg-none pantallasp">
        <li className="d-flex align-items-center justify-content-center">
          <a className="navbar-brand d-flex  link-body-emphasis text-decoration-none" href="/">
            <img src="/imagenes/marca/clvhorizontalblanco.png" alt="Logo" className="logo-navbar small-logo" />
          </a>
        </li>

        {/* Ícono de lupa que abre el modal */}
        <li className="nav-item d-flex align-items-center">
          <i
            className="bi bi-search nav-icon text-white"
            data-bs-toggle="modal"
            data-bs-target="#modalBusqueda"
            title="Abrir búsqueda"
          ></i>
        </li>

        {/* Botón de menú Offcanvas */}
        <button
          className="btn btn-menu-offcanvas d-lg-none" // Solo en pantallas pequeñas
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasMenu"
          aria-controls="offcanvasMenu"
          title="Abrir menú lateral"
        >
          <i className="bi bi-list text-white"></i>
        </button>


        {/* Menú Offcanvas */}
        <div className="offcanvas offcanvas-start" tabIndex="-1" id="offcanvasMenu" aria-labelledby="offcanvasMenuLabel" style={{ backgroundColor: 'black'}}>
          <div className="offcanvas-header" >
            {/* Imagen alineada a la derecha */}
            <div className="offcanvas-logo-container w-100 d-flex " style={{marginLeft: "0px" }}>
              <img src="/imagenes/marca/clvhorizontalblanco.png" alt="Logo"   className="logo-navbar small-logo" style={{ width: '80px' }} />
            </div>
            {/* botón cerrar */}
            <button type="button" className="btn-close text-reset border border-white rounded-3" data-bs-dismiss="offcanvas" aria-label="Cerrar" style={{   backgroundColor: 'white',  borderColor: 'white', position: 'absolute', top: '20px',  right: '20px', }}  ></button>
          </div>
          {/* Menú */}
          <div className="offcanvas-body" style={{ backgroundColor: 'var(--e-global-color-primary)' }}>
            {/* Menú */}
            <ul className="list-unstyled" style={{ opacity: 0, transition: 'opacity 0.5s ease', visibility: 'hidden' }}>
              <li><a className="nav-link text-white text-small" href="/videos">VER VIDEOS</a></li>
              <li><a className="nav-link text-white text-small" href="/ver-videos/futbol">TORNEOS</a></li>
              <li><a className="nav-link text-white text-small" href="/paga-y-graba">GRABAR</a></li>
              <hr style={{color: "white"}} />
              {!usuario ? null : <>
                <li><a className="nav-link text-white text-small" href={"/cliente/mi-cuenta/"  + usuario.username}>MI CUENTA</a></li>
                <li><a className="nav-link text-white text-small" href={"/cliente/partidos/"   + usuario.username}>GRABAR</a></li>
                <li><a className="nav-link text-white text-small" href={"/cliente/pagos/"      + usuario.username}>MIS PAGOS</a></li>
                <li><a className="nav-link text-white text-small" href={"/cliente/mis-videos/" + usuario.username + "/1"}>MIS VIDEOS</a></li>
                <hr style={{color: "white"}} />
                <li><button onClick={cerrarSesion} className="nav-link text-white text-small" type="button">CERRAR SESIÓN</button></li>
              </>
              }
            </ul>
          </div>
        </div>
      </ul>

      {/* Contenedor de los enlaces y botones en pantallas grandes */}
      <ul className="barra mb-2 mb-sm-0 d-flex align-items-center mx-5 d-none d-lg-flex">
        <li className="d-flex align-items-center">
          <a className="navbar-brand d-flex align-items-center mb-3 mb-lg-0 me-lg-auto link-body-emphasis text-decoration-none" href="/">
            <img src="/imagenes/marca/clvhorizontalblanco.png" alt="Logo" className="logo-navbar" />
          </a>
        </li>
        <li className="nav-item dropdown d-none d-lg-flex">
          <a className="nav-link nav-torneos  text-small" href="/videos">VER VIDEOS</a>
        </li>
        <li className="nav-item d-none d-lg-flex">
          <a className="nav-link nav-torneos text-small" href="/ver-videos/futbol">TORNEOS</a>
        </li>
        <li className="nav-item d-none d-lg-flex">
          <a className="nav-link nav-torneos  text-small" href="/paga-y-graba">GRABAR</a>
        </li>
        <li className="nav-item d-flex align-items-center d-none d-lg-flex mx-1">
          <i className="bi bi-search nav-torneos text-small" data-bs-toggle="modal" data-bs-target="#modalBusqueda" title="Abrir búsqueda"></i>
          <span className="text-white filtrar-texto  ms-2 text-small" title="Buscar">BUSCAR</span>
        </li>
      </ul>

      {/* Segunda parte del menú con los botones (Iniciar sesión, Registrar) */}
      {!usuario ?
      <div id="contenedorSegundaParteHeader" className="col-md-4 text-md-end text-center headerFinal">
        <button className="btn btn-iniciar-sesion me-3 w-100" type="button" onClick={iniciarsesion}>Iniciar Sesión</button>
        <button className="btn btn-registrar w-100" type="button" onClick={registrar}>Registrar</button>
      </div>
      :<div id="contenedorSegundaParteHeader" className="d-none d-md-flex justify-content-end col-md-4 headerFinal">
        <div className="btn-group">
          {/* Icono */}
          <button type="button" className="btn dropdown-toggle p-0 border-0 bg-transparent" data-bs-toggle="dropdown"  aria-expanded="false"  >
            <img src={usuario.avatar} alt="Avatar" width="40" height="40"  className="rounded-circle" />
          </button>
          {/* Menú */}
          <ul className=" dropdown-menu dropdown-menu-end py-3 px-3">
            <li><a className="dropdown-item" href={"/cliente/mi-cuenta/"  + usuario.username}>MI CUENTA</a></li>
            <li><a className="dropdown-item" href={"/cliente/partidos/"   + usuario.username}>GRABAR</a></li>
            <li><a className="dropdown-item" href={"/cliente/mis-videos/" + usuario.username + "/1"}>MIS VIDEOS</a></li>
            <li><a className="dropdown-item" href={"/cliente/pagos/"      + usuario.username}>MIS PAGOS</a></li>
            <hr />
            <li><button onClick={cerrarSesion} className="dropdown-item" type="button">CERRAR SESIÓN</button></li>
          </ul>
          </div>
      </div>
      }
      </div>
    </header>

    {/* Modal de búsqueda */}
    <div className="modal fade modal-123" id="modalBusqueda" tabIndex="-1" aria-labelledby="modalBusquedaLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content-123 w-100">
          {/* <div className="modal-header w-100">
            <h5 className="modal-title" id="modalBusquedaLabel">Búsqueda</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Cerrar"></button>
          </div> */}
          <div className="modal-body w-100">
            <ContenedorFiltrosGlobal  cualBusqueda={ejectuarBusqueda} /> 
          </div>
        </div>
      </div>
    </div>
  </div>    
  )
}

export default HeaderGlobal;